"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.placeholders = void 0;
var _types = require("../../../../../types");
const placeholders = exports.placeholders = {
  desktop: {
    [_types.EEstimationTargets.flat]: 'Населенный пункт, улица, дом',
    [_types.EEstimationTargets.house]: 'Населенный пункт, улица, дом',
    [_types.EEstimationTargets.land]: 'Населенный пункт, улица',
    [_types.EEstimationTargets.newbuilding]: 'Адрес или название ЖК'
  },
  mobile: {
    [_types.EEstimationTargets.flat]: 'Населенный пункт, улица, дом',
    [_types.EEstimationTargets.house]: 'Населенный пункт, улица, дом',
    [_types.EEstimationTargets.land]: 'Населенный пункт, улица',
    [_types.EEstimationTargets.newbuilding]: 'ЖК Скандинавский луг'
  }
};